import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './ExperienceItem.css';
// import ExperienceItem from './ExperienceItem.js';


function ExperienceItem({ experience, isVisible }) {

  return (
    <div className={`timeline-item fade-in ${isVisible ? 'visible' : ''}`}>
        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                <div>
                    <h3 className="text-xl font-bold text-gray-800">{experience.title}</h3>
                    <p className="text-emerald-600 font-semibold">{experience.company}</p>
                </div>
                <div className="text-gray-500 text-sm mt-2 md:mt-0">
                    <span className="bg-gray-100 px-3 py-1 rounded-full">{experience.period}</span>
                </div>
            </div>
            <p className="text-gray-600 mb-4">{experience.description}</p>
            <div className="grid md:grid-cols-2 gap-4">
                <div>
                    <h4 className="font-semibold text-gray-800 mb-2">Key Achievements:</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                        {experience.achievements.map((achievement, index) => (
                            <li key={index}>• {achievement}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="font-semibold text-gray-800 mb-2">Responsibilities:</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                        {experience.responsibilities.map((responsibility, index) => (
                            <li key={index}>• {responsibility}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ExperienceItem;